<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Wallet</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/wallet">Wallet</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">

                <div v-if="mode == ''">
                  <button type="button" class="btn btn-secondary btn-block mb-1" v-on:click="payEft">Pay With EFT</button>
                  <button type="button" class="btn btn-secondary btn-block mb-1" v-on:click="payCard">Pay With Card</button>
                </div>

                <div v-if="mode == 'eft'" class="text-center">
                  <p>Please deposit the amount you require at any ABSA cash accepting ATM, ABSA branch or via online payment.</p>

                  <p><strong>Account Number: 4093427948<br />
                    Branch No: 632005<br />
                    Use 0319034666 as reference</strong>
                  </p>

                  <p>Once your money has cleared you will be notified by SMS.</p>

                  <p>Please feel free to drop us a mail about it at <a href="mailto:support@goldenspoon.co.za">support@goldenspoon.co.za</a>. Alternatively please visit <a href="https://goldenspoon.co.za" target="_blank">goldenspoon.co.za</a> to review the instructions or fill out a form and we will get back to you in no time!</p>

                  <button type="button" class="btn btn-secondary btn-block mb-1" v-on:click="showOptions">Back</button>
                </div>

                <div v-if="mode == 'card'" class="text-center">
                  <table class="table table-striped cards-table">
                    <tbody>
                      <tr v-for="card in cards" v-bind:key="card.id">
                        <td class="text-left">
                          {{card.card_name}} {{card.name}}<br /><br />
                          <div class="text-center">
                            <button type="button" class="btn btn-primary" v-on:click="showCvv(card.token)">Pay With Card</button> &nbsp;
                            <button type="button" class="btn btn-danger" v-on:click="deleteCard(card.id)" data-toggle="modal" data-target="#delete-card-modal">Delete Card</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <button type="button" class="btn btn-primary btn-block" v-on:click="newCard">Pay with new card</button><br />

                  <button type="button" class="btn btn-secondary btn-block mb-1" v-on:click="showOptions">Back</button>
                </div>

                <div v-if="mode == 'cvv'">
                  <div class="col-md-12">
                    <form action="#" class="cvv-form">
                      <fieldset>
                        <label for="pay_amount">What amount would you like to add to your wallet?</label>
                        <div class="form-group">
                          <input type="text" class="form-control" name="pay_amount" id="pay_amount" v-model="pay_amount" placeholder="Amount in Rands">
                        </div>
                      </fieldset>
                      <fieldset>
                        <label for="pay_cvv">Credit Card CVV / Code</label>
                        <div class="form-group">
                          <input type="text" class="form-control" name="pay_cvv" id="pay_cvv" v-model="pay_cvv">
                        </div>
                      </fieldset>
                      <button type="button" class="btn btn-primary btn-block" v-on:click="confirmPayment">Make Payment</button><br />
                    </form>
                  </div>
                </div>

                <div v-if="mode == 'new'">

                  <div class="row">
                    <div class="col-md-12">
                      <div class='card-wrapper mb-2'></div>
                    </div>
                    <div class="col-md-12">
                      <form action="#" class="card-form">
                        <fieldset>
                          <label for="card_name">Card Holder's Name</label>
                          <div class="form-group">
                            <input type="text" class="form-control card-name" name="name" id="card_name" v-model="card_name">
                          </div>
                        </fieldset>
                        <fieldset>
                          <label for="card_number">Card Number</label>
                          <div class="form-group">
                            <input type="text" class="form-control card-number" name="number" id="card_number" maxlength="19" v-model="card_number">
                          </div>
                        </fieldset>
                        <div class="row">
                          <div class="col-md-6">
                            <fieldset>
                              <label for="card_expiry">Expiry Date</label>
                              <div class="form-group">
                                <input type="text" class="form-control card-expiry" name="expiry" id="card_expiry" v-model="card_expiry" placeholder="MM/YYYY">
                              </div>
                            </fieldset>
                          </div>
                          <div class="col-md-6">
                            <fieldset>
                              <label for="cvv">CVC Number</label>
                              <div class="form-group">
                                <input type="text" class="form-control card-cvc" name="cvc" id="cvv" maxlength="16" v-model="cvv">
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <button type="button" class="btn btn-primary btn-block" v-on:click="addCard">Add Card</button><br />

                  <button type="button" class="btn btn-secondary btn-block mb-1" v-on:click="showOptions">Back</button>
                </div>

                <div v-if="mode == '3ds'">
                  <form action="https://secure.paygate.co.za/PayHost/redirect.trans" method="post" id="3ds-form" target="secureIframe">
                    <p>To complete adding your card, we need to authenticate you using 3D secure.</p>
                    <p><strong>R2 will be deducted from your account and added to your wallet.</strong></p>
                    <p>Please click on the button below to start the authentication process:</p>
                    <input type="hidden" v-for="variable in secureVariables" v-bind:key="variable.xkey" v-bind:value="variable.xval" v-bind:name="variable.xkey" v-bind:id="variable.xkey" />
                    <input type="submit" class="btn btn-block btn-primary" value="Perform 3D Secure Authentication" />
                  </form>

                  <iframe name="secureIframe" id="secureIframe" frameBorder="0" style="width:100%;height:800px;border:none;display:none"></iframe>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="modal fade text-left" id="delete-card-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-danger white">
            <h4 class="modal-title white" id="myModalLabel10">Delete Card</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>Are you sure?</h5>
            <p>By deleting your card you will have to upload your card details again if you want to use this card.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn grey btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="confirmCardDelete()">Delete Card</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Card from 'card'
import swal from 'sweetalert'

export default {
  name: 'wallet',
  data: function () {
    return {
      mode: '',
      cards: [],
      card_name: '',
      card_number: '',
      card_expiry: '',
      cvv: '',
      token: '',
      pay_amount: '',
      pay_cvv: '',
      secureVariables: [],
      timer: ''
    }
  },
  mounted: function () {
    var that = this

    $(document).on('submit', '#3ds-form', function (e) {
      // e.preventDefault()
      var payRequestId = $('#PAY_REQUEST_ID').val()

      $('#3ds-form').hide()
      $('#secureIframe').show()

      that.timer = setInterval(function () {
        $.ajax({
          url: that.$config.apiUrl + 'cards/payment_ping',
          type: 'post',
          data: 'PAY_REQUEST_ID=' + payRequestId,
          dataType: 'json',
          beforeSend: function (xhr) {
            // Do nothing. i.e. don't show loading bar
            if (window.localStorage.getItem('token')) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            }
          },
          complete: function () {
            $.hideLoading()
          },
          success: function (data) {
            if (data.data.TransactionStatusDescription === 'Pending') {
              // Do nothing
            } else {
              that.clearTimer()

              swal({
                title: 'Success',
                text: 'Card Successfully added. You can add funds now',
                icon: 'success',
                button: 'Ok'
              }).then(function () {
                that.$router.push('/wallet')
                that.mode = 'card'
                that.payCard()
              })
            }
          }
        })
      }, 5000)
    })
  },
  methods: {
    clearTimer: function () {
      clearInterval(this.timer)
    },
    hide3dForm: function () {
      $('#3ds-form').hide()
    },
    payEft: function () {
      this.mode = 'eft'
    },
    payCard: function () {
      this.mode = 'card'
      var that = this

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'cards/cards',
        type: 'get',
        success: function (data) {
          that.cards = data.data
        }
      })
    },
    showOptions: function () {
      this.mode = ''
    },
    newCard: function () {
      this.mode = 'new'

      setTimeout(function () {
        // eslint-disable-next-line
        var card = new Card({
          form: '.card-form',
          container: '.card-wrapper',
          width: 200,
          formatting: true,
          messages: {
            validDate: 'valid\ndate',
            monthYear: 'mm/yyyy'
          },
          placeholders: {
            number: '•••• •••• •••• ••••',
            name: 'Full Name',
            expiry: '••/••',
            cvc: '•••'
          },
          masks: {
            cardNumber: '•'
          },
          debug: false
        })
      }, 100)
    },
    addCard: function () {
      var that = this
      var cardNumber = $('#card_number').val()
      cardNumber = cardNumber.replace(/ /g, '') // Replace all spaces

      var expiry = $('#card_expiry').val().split('/')
      var month = 0
      var year = 0

      if (expiry.constructor === Array && expiry.length === 2) {
        month = expiry[0].trim()
        year = expiry[1].trim()

        if (year.length === 2) {
          year = '20' + year
        }
      }

      var data = {
        card_name: $('#card_name').val(),
        card_number: cardNumber,
        exp_year: year,
        exp_month: month,
        cvv: $('#cvv').val()
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'cards/card_3d',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          $.hideLoading()
          if (!data) {
            swal({
              title: 'Error',
              text: 'Card could not be added',
              icon: 'error',
              button: 'Ok'
            })
          } else {
            if (typeof data.success !== 'undefined' && data.success === true) {
              for (var key in data.data.UrlParams) {
                that.secureVariables.push({
                  xkey: key,
                  xval: data.data.UrlParams[key].xval
                })
              }

              that.mode = '3ds'
            } else {
              swal({
                title: 'Error',
                text: 'Card could not be added',
                icon: 'error',
                button: 'Ok'
              })
            }
          }

          return false
        },
        error: function (data) {
          $.hideLoading()

          swal({
            title: 'Error',
            text: data.responseJSON.message,
            icon: 'error',
            button: 'Ok'
          })
        }
      })
    },
    deleteCard: function (cardId) {
      window.localStorage.setItem('deleteCardId', cardId)
    },
    confirmCardDelete: function () {
      var that = this
      var cardId = window.localStorage.getItem('deleteCardId')

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'cards/card/' + cardId,
        type: 'delete',
        dataType: 'json',
        success: function (data) {
          swal({
            title: 'Success',
            text: 'Credit Card Deleted',
            icon: 'success',
            button: 'Ok'
          }).then(function () {
            $.ajax({
              url: that.$config.apiUrl + 'cards/cards',
              type: 'get',
              success: function (data) {
                $.hideLoading()
                that.cards = data.data
              }
            })
          })
        }
      })
    },
    showCvv: function (token) {
      this.token = token
      this.mode = 'cvv'
    },
    confirmPayment: function () {
      var that = this

      var data = {
        card_token: this.token,
        amount: this.pay_amount,
        cvv: this.pay_cvv
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        url: this.$config.apiUrl + 'cards/payment',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          $.hideLoading()

          if (typeof data.success !== 'undefined' && data.success === true) {
            swal({
              title: 'Success',
              text: 'Credit Card Payment Successful',
              icon: 'success',
              button: 'Ok'
            })

            that.$router.push('/')

            // Now update the wallet balance.
            var currentObj = JSON.parse(window.localStorage.getItem('user'))
            var currentBalance = parseInt(currentObj.wallet_balance)
            var addedBalance = parseInt(that.pay_amount)
            var newBalance = currentBalance + addedBalance

            currentObj.wallet_balance = newBalance
            window.localStorage.setItem('user', JSON.stringify(currentObj))
          } else {
            $.hideLoading()

            swal({
              title: 'Error',
              text: 'Credit Card Payment Declined',
              icon: 'error',
              button: 'Ok'
            })
          }

          return false
        },
        error: function (data) {
          $.hideLoading()
          var reason = data.responseJSON.message

          swal({
            title: 'Error',
            text: reason,
            icon: 'error',
            button: 'Ok'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.cards-table td {
  vertical-align: middle;
  padding:10px 0;
  border-top:none;
}

</style>
